import { Actions, Page } from 'gatsby';
import {
  Institution, Country, CountryCalculation, FS_TYPES,
} from '../../types';
import { languages } from '../i18n';

export interface FSCompareContext {
  countries: Country[],
  institutions: Institution[],
  countryCalculations: CountryCalculation[],
}

export const filterFSComparisonByLocale = (page: Page<FSCompareContext>, actions: Actions) => {
  FS_TYPES.forEach(fsType => {
    if ([...languages, ''].map(lang => new RegExp(`^/${lang}/?${fsType}s/compare/?$`)).some(path => page.path.match(path))) {
      const { createPage, deletePage } = actions;

      // intl is injected by the intl plugin, so of course Gatsby's TS doesn't know about it
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const language = page.context.intl.language;
      const { countries, institutions, countryCalculations } = page.context;

      deletePage(page);
      createPage({
        ...page,
        context: {
          ...page.context,
          countries: countries.filter(c => c.language === language),
          institutions: institutions.filter(i => i.language === language),
          countryCalculations: countryCalculations.filter(cc => cc.language === language),
        },
      });
    }
  });
};
